import axios from 'axios';

import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import config from '@/config/config.ts';
import {
  Thunder,
} from '@/pt9800/generated/zeus';

export interface FetchGraphOptions {
  location: string,
}

const axiosClient = axios.create({
  baseURL: config.VITE_APP_API_PT9800_URL,
});

keycloakAuthenticationHandler.secureAxiosClient(axiosClient);

const fetchGraph = async (query: string, context: FetchGraphOptions) => {
  const requestConfig = {
    params: {
      ptDbId: context.location,
    },
  };

  return axiosClient
    .post('graphql', {
      query,
    }, requestConfig)
    .then((result) => ({
      json: () => result.data,
    }));
};

const fetchGraphJSON = (query: string, context: FetchGraphOptions) => fetchGraph(query, context).then((response: any) => response.json());

const thunder = Thunder(async (query, variables) => {
  const location = variables?.location as string;
  if (!location) {
    throw new Error('Variable {location} is missing');
  }
  return (await fetchGraphJSON(
    query,
    {
      location,
    },
  )).data;
});

const pt9800APIClient = {
  axios: axiosClient,
  fetchGraph,
  fetchGraphJSON,
};

export {
  pt9800APIClient,
  thunder,
};
